import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const TweeterIcon = (props: SvgProps) => (
  <Svg
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="m10.456 7.794 5.696-6.669h-1.35l-4.945 5.79-3.95-5.79H1.35l5.974 8.757-5.974 6.993H2.7l5.222-6.116 4.173 6.116h4.556l-6.195-9.081ZM8.607 9.959l-.605-.872-4.816-6.938h2.073l3.886 5.599.605.872 5.053 7.279h-2.074l-4.122-5.94Z"
    />
  </Svg>
)
export default TweeterIcon
